import Parser from 'html-react-parser';
import React, { useContext } from 'react';
import AppContext from '../../context/app/appContext';

const Post = ({ post }) => {
  const appContext = useContext(AppContext);

  const {postType} = appContext;
  let postTerms = [];

  const {
    link,
    title,
    featureImage,
    fallbackIconClass,
    taxonomies,
    dateFormated,
    readMoreText
  } = post;

  const intersperse = (arr, sep) => {
    if (arr.length === 0) {
        return [];
    }

    return arr.slice(1).reduce(function(xs, x, i) {
        return xs.concat([sep, x]);
    }, [arr[0]]);
  }

  if(taxonomies) {
    postTerms = taxonomies.map((term, i) => {
      return(
        <span key={i} className="d-inline-block category-label">{term.name}</span>
      )
    });
    postTerms = intersperse(postTerms, ", ");
  }

  return (
    <div className={`col-6 col-md-4 col-lg-3 card ${postType}`}>
        <div className="card-inner d-flex flex-column h-100">
          <a href={link} title={Parser(title)} className="d-block">
            {featureImage ? (
              <figure className="aspect-ratio-1-1 d-flex align-items-center justify-content-center mx-auto card-media-container text-center" dangerouslySetInnerHTML={{ __html: featureImage }} />
            ) : (
              <figure className="d-flex align-items-center justify-content-center mx-auto card-media-container text-center card-media-fallback">
                <i className={fallbackIconClass}></i>
              </figure>
            )}
          </a>

          {postTerms &&
          <div className="card-categories mt-2 mt-md-3">
            {postTerms}
          </div>
          }

          <div className="card-content">

            <h4 className="card-title">
              <a href={link} title={Parser(title)} className="d-block">
                {Parser(title)}
              </a>
            </h4>

            <div className="card-date mb-2 mb-md-3">
              <p className="small-date-title">{dateFormated}</p>
            </div>

            <div className="card-link">
              <a
                href={link}
                className="link-label no-underline d-inline-block icon-text-link-arrow"
                title={Parser(readMoreText)}>
                  {Parser(readMoreText)}
                </a>
            </div>

          </div>

        </div>
    </div>
  );
};

export default Post;



// WEBPACK FOOTER //
// ./src/components/Posts/Post.js